import useSWR, { SWRConfiguration } from 'swr';
import {
  getApprovalChatMessagesUrl,
  getApprovalChatSessionsUrl,
  getApprovalChatSuggestionUrl,
  getApprovalChatUrl,
} from '@/constant/approval';
import {
  getNestedDataFetcher,
  patchDataFetcher,
  postDataFetcher,
} from '@/utils/apis';
import type {
  ApprovalChatMessage,
  ApprovalChatSendRequest,
  ApprovalChatSendResponse,
  ApprovalChatSession,
  ApprovalChatSuggestionState,
} from '@/types/approvalChat';

// 질문 송신 — 비동기(202). 답변은 응답의 topic 으로 SSE 수신.
export const postApprovalChat = (
  documentId: string,
  body: ApprovalChatSendRequest,
) =>
  postDataFetcher<ApprovalChatSendRequest, { data: ApprovalChatSendResponse }>(
    getApprovalChatUrl(documentId),
    body,
  );

// 본인 세션 목록 (최근 갱신순)
export const useApprovalChatSessions = (
  documentId?: string,
  config?: SWRConfiguration,
) =>
  useSWR<ApprovalChatSession[]>(
    documentId ? getApprovalChatSessionsUrl(documentId) : null,
    getNestedDataFetcher,
    config,
  );

// 세션 메시지 이력 (최신순). beforeId 로 과거 페이지.
export const getApprovalChatMessages = (
  documentId: string,
  sessionId: string,
  params?: { limit?: number; beforeId?: string },
) => {
  const query = new URLSearchParams();
  if (params?.limit) query.append('limit', String(params.limit));
  if (params?.beforeId) query.append('beforeId', params.beforeId);
  const qs = query.toString();
  return getNestedDataFetcher<ApprovalChatMessage[]>(
    `${getApprovalChatMessagesUrl(documentId, sessionId)}${qs ? `?${qs}` : ''}`,
  );
};

// 제안 카드 응답 기록 — 패널을 다시 열어도 카드가 처리됨으로 보이게. 결재 처리 자체는 confirm/reject API.
export const patchApprovalChatSuggestion = (
  documentId: string,
  sessionId: string,
  messageId: string,
  state: ApprovalChatSuggestionState,
) =>
  patchDataFetcher<{ state: ApprovalChatSuggestionState }>(
    getApprovalChatSuggestionUrl(documentId, sessionId, messageId),
    { state },
  );
